import { graphql } from '../gql'

/**
 * GraphQL operations for order mutations.
 */

/** Query: Get cancellation reasons. */
export const GetOrderCancellationReasons = graphql(`
	query GetOrderCancellationReasons($where: QueryOrderCancellationReasonsWhereInput) {
		orderCancellationReasons(where: $where) {
			name
			slug
			sort
		}
	}
`)

/** Mutation: Cancel an order. */
export const CancelOrderMutation = graphql(`
	mutation CancelOrder(
		$id: Int!
		$comment: CommentInput!
		$cancellationReason: String
	) {
		updateOrder(
			data: {
				revision: -42
				status: "cancelled"
				cancellationReason: $cancellationReason
				comments: { create: [$comment] }
			}
			where: { id: $id }
		) {
			id
			status
			statusDetails {
				slug
				name
			}
			cancellationReason
		}
	}
`)
